const translation = {
	PageSize: 'Page Size',
	PageOrientation: 'Page Orientation',
	Format: 'Format',
	DPI: 'DPI',
	Generate: 'Generate'
};

export default translation;
